'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var Typography = require('../../../DesignSystem/DataDisplay/Typography/Typography.js');
var makeStyles = require('../../../DesignSystem/Styles/makeStyles.js');
var Radio = require('../../../IconsAndImages/Icons/Radio.js');
var RadioDot = require('../../../IconsAndImages/Icons/RadioDot.js');
var useFormColors = require('../../Styles/useFormColors.js');
var classNames = require('classnames');
var FormControlLabel = require('../../../node_modules/@material-ui/core/esm/FormControlLabel/FormControlLabel.js');
var Radio$1 = require('../../../node_modules/@material-ui/core/esm/Radio/Radio.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useStyles = function useStyles(error, disabled) {
  return makeStyles["default"](function (theme) {
    var _theme$palette, _theme$palette$error, _theme$palette2, _theme$palette2$black, _theme$palette3, _theme$palette4, _theme$palette5, _theme$palette6;

    var _useFormColors = useFormColors(error, disabled),
        lightColor = _useFormColors.lightColor,
        mainColor = _useFormColors.mainColor,
        disabledColor = _useFormColors.disabledColor,
        blackColor = _useFormColors.blackColor,
        helperColor = _useFormColors.helperColor;

    var restingColor = disabled ? disabledColor : error ? (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$error = _theme$palette.error) === null || _theme$palette$error === void 0 ? void 0 : _theme$palette$error.main : (_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 ? void 0 : (_theme$palette2$black = _theme$palette2.black) === null || _theme$palette2$black === void 0 ? void 0 : _theme$palette2$black.primary;
    return {
      root: {
        stroke: mainColor,
        '&:hover': {
          backgroundColor: 'transparent !important'
        },
        '& $rect': {
          strokeWidth: error && !disabled ? 4 : 2
        }
      },
      iconOffset: {
        marginBottom: theme.spacing(2)
      },
      svgChecked: {
        width: '18px !important',
        height: '18px !important',
        fill: 'transparent',
        borderRadius: 8.5,
        '& $rect:nth-child(2)': {
          stroke: 'transparent',
          fill: mainColor
        }
      },
      svgUnChecked: {
        width: '18px !important',
        height: '18px !important',
        borderRadius: 8.5,
        stroke: restingColor,
        fill: 'transparent'
      },
      labelStyle: {
        color: blackColor
      },
      labelHelper: {
        color: helperColor,
        lineHeight: 1,
        marginTop: theme.spacing(0.5)
      },
      disabledStyle: {},
      container: {
        display: 'flex',
        flexDirection: 'column'
      },
      wrapper: {
        outline: '1px solid',
        outlineColor: 'transparent',
        borderRadius: 9,
        outlineOffset: 1,
        transition: 'outline-color 0.5s',
        display: 'flex'
      },
      formLabel: {
        marginLeft: 0,
        marginRight: 0,
        "&:focus-within": {
          "& $wrapper": {
            outlineColor: mainColor
          },
          "& $svgChecked": {
            '& $rect:nth-child(1)': {
              strokeWidth: 4
            },
            '& $rect:nth-child(2)': {
              fill: lightColor,
              stroke: lightColor,
              strokeWidth: 0
            }
          },
          "& $svgUnChecked": {
            '& $rect:nth-child(1)': {
              strokeWidth: 4,
              stroke: mainColor
            },
            '& $rect:nth-child(2)': {
              fill: (_theme$palette3 = theme.palette) === null || _theme$palette3 === void 0 ? void 0 : _theme$palette3.secondary[400],
              stroke: (_theme$palette4 = theme.palette) === null || _theme$palette4 === void 0 ? void 0 : _theme$palette4.secondary[400],
              strokeWidth: 0
            }
          }
        },
        "&:not($disabledStyle):hover": {
          "& $svgChecked": {
            '& $rect:nth-child(1)': {
              strokeWidth: 4
            },
            '& $rect:nth-child(2)': {
              fill: lightColor,
              stroke: lightColor,
              strokeWidth: 0
            }
          },
          "& $svgUnChecked": {
            '& $rect:nth-child(1)': {
              strokeWidth: 4,
              stroke: mainColor
            },
            '& $rect:nth-child(2)': {
              fill: (_theme$palette5 = theme.palette) === null || _theme$palette5 === void 0 ? void 0 : _theme$palette5.secondary[400],
              stroke: (_theme$palette6 = theme.palette) === null || _theme$palette6 === void 0 ? void 0 : _theme$palette6.secondary[400],
              strokeWidth: 0
            }
          }
        }
      }
    };
  });
};

var RadioV2 = React__default["default"].forwardRef(function (_ref, ref) {
  var label = _ref.label,
      helperText = _ref.helperText,
      error = _ref.error,
      disabled = _ref.disabled,
      rest = objectWithoutProperties(_ref, ["label", "helperText", "error", "disabled"]);

  var _useStyles = useStyles(error, disabled)(),
      root = _useStyles.root,
      svgChecked = _useStyles.svgChecked,
      svgUnChecked = _useStyles.svgUnChecked,
      labelStyle = _useStyles.labelStyle,
      formLabel = _useStyles.formLabel,
      disabledStyle = _useStyles.disabledStyle,
      labelHelper = _useStyles.labelHelper,
      wrapper = _useStyles.wrapper,
      iconOffset = _useStyles.iconOffset;

  var checkedIcon = React__default["default"].createElement("div", {
    className: wrapper
  }, React__default["default"].createElement(RadioDot, {
    classes: {
      root: svgChecked
    }
  }));
  var icon = React__default["default"].createElement("div", {
    className: wrapper
  }, React__default["default"].createElement(Radio, {
    classes: {
      root: svgUnChecked
    }
  }));
  var disabledClass = disabled ? disabledStyle : '';
  return React__default["default"].createElement(FormControlLabel["default"], {
    classes: {
      root: formLabel
    },
    className: disabledClass,
    control: React__default["default"].createElement(Radio$1["default"], _objectSpread({
      classes: {
        root: classNames__default["default"](root, helperText && iconOffset)
      },
      ref: ref,
      disableRipple: true,
      disabled: disabled,
      checkedIcon: checkedIcon,
      icon: icon
    }, rest)),
    label: React__default["default"].createElement(React__default["default"].Fragment, null, React__default["default"].createElement(Typography, {
      className: labelStyle,
      variant: "body1"
    }, label), helperText && React__default["default"].createElement(Typography, {
      className: labelHelper,
      variant: "caption"
    }, helperText))
  });
});

module.exports = RadioV2;
